import { styled } from '@mui/material/styles';
import { ButtonProps } from '@mui/material/Button';
import { Stack } from '@mui/system';
import { TEMPLATE_TABS } from '../../constants/cards';
import { Tabs } from '../../types/common';
import { ButtonUnstyled } from '@mui/base';
// import theme from "../../styles/theme";

type StyledButtonProps = ButtonProps & { active: string };

const StyledButton = styled(ButtonUnstyled)<StyledButtonProps>(({ active, theme }) => ({
  fontFamily: 'Montserrat',
  cursor: 'pointer',
  fontSize: '12px',
  borderRadius: '30px',
  padding: '6px 10px',
  color: active ? theme.custom.palette.primary.white : theme.custom.palette.primary.black,
  border: active
    ? `1px solid ${theme.custom.palette.primary.white}`
    : `1px solid ${theme.custom.palette.primary.lightgray}`,
  backgroundColor: active ? theme.custom.palette.primary.default : theme.custom.palette.primary.white,
  '&:hover': {
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)',
  },
}));

interface ITemplateTabsProps {
  activeTab: Tabs['id'];
  onClick: (id: Tabs['id']) => void;
}

const TemplateTabs: React.FC<ITemplateTabsProps> = ({ onClick, activeTab }) => {
  return (
    <Stack direction={'row'} gap={'10px'} flexWrap={'wrap'}>
      {TEMPLATE_TABS.map((group) => (
        <StyledButton
          key={group.id}
          variant="outlined"
          onClick={() => onClick(group.id)}
          active={activeTab === group.id ? 'primary' : ''}
        >
          {group.name}
        </StyledButton>
      ))}
    </Stack>
  );
};

export default TemplateTabs;
